export const OUTBOUND_MSG_TYPE = {
    ERROR: "ERROR",
    CALL_CREATED: "CALL_CREATED",
    CALL_INCOMING: "CALL_INCOMING",
    CALL_ACCEPTED: "CALL_ACCEPTED",
    CALL_RECONNECTING: "CALL_RECONNECTING",
    CALL_IN_CALL: "CALL_IN_CALL",
    CALL_RESUMED: "CALL_RESUMED",
    CALL_ENDED: "CALL_ENDED",
    PONG: "PONG",
    WELCOME: "WELCOME",
    SDP_OFFER: "SDP_OFFER",
    SDP_ANSWER: "SDP_ANSWER",
    ICE_CANDIDATE: "ICE_CANDIDATE",
    CALL_STATE: "CALL_STATE",
};
